import { Editor, Point } from 'slate';
export function getCursorPositionInNode(editor, cursorLocation, nodePath) {
  var nodeStartPoint = Editor.start(editor, nodePath);
  var nodeEndPoint = Editor.end(editor, nodePath);
  var isStart = Point.equals(cursorLocation, nodeStartPoint);
  var isEnd = Point.equals(cursorLocation, nodeEndPoint);
  return {
    isEnd,
    isStart
  };
}